// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1rT_z","headerWrap":"_3ie-T","contentWrapper":"_3q6SZ","description":"_2Qj1Z","zoneHeading":"_3HB8D","zonetitle":"_26pwn","zoneDetail":"_3QuRr"};